import React from "react";
import { useTranslation } from "react-i18next";
import { lifetimePredictionConfig } from "../AdvancedSettings.config";
import SliderCard from "../../../../components/SliderCard";
import WPHeading from "../../../../packages/WPHeading";
import IconWithTooltip from "../../../../common/styles/components/headings/IconWithTooltip";

const LifetimePrediction = ({
  resetKey,
  settings,
  suggestedSettings,
  handleChange,
  defaultSettings,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="info-section">
        <WPHeading fontNoto size="small" className="mt-24">
          {t("advanceSettings.lifetime")}
        </WPHeading>
        <IconWithTooltip label={t("helpInformation.lifetimePredictionHelp")} />
      </div>
      <div className="slider-cards-group">
        {Object.entries(lifetimePredictionConfig).map(([apiKey, config]) => {
          const isRecommended = suggestedSettings[apiKey] != null;
          return (
            <div key={`${apiKey}-${resetKey}`} className="slider-card-container">
              <SliderCard
                min={config.minValue}
                max={config.maxValue}
                label={t(`advanceSettings.${config.key}`)}
                isInteger={config.integer}
                inputValue={settings[apiKey] ?? defaultSettings[apiKey] ?? ""}
                recommended={isRecommended ? suggestedSettings[apiKey] : null}
                onChange={(val) =>
                  handleChange({
                    type: "slider",
                    key: apiKey,
                    value: val,
                    min: config.ranges?.hard?.min ?? config.minValue,
                    max: config.ranges?.hard?.max ?? config.maxValue,
                  })
                }
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default LifetimePrediction;
